<div class="card">
  <ng-container *ngIf="listType !== 'archive'">
    <div class="ng-Header col-xs-12">
      <i nz-icon nzType="search" nzTheme="outline"></i> Search
    </div>
    <form
      nz-form
      [formGroup]="searchingForm"
      (ngSubmit)="onSearch()"
      style="padding: 16px 24px; background: #fbfbfb; border: 1px solid #d9d9d9; border-radius: 6px"
    >
      <div nz-row [nzGutter]="16">
        <div nz-col [nzXs]="24" [nzSm]="12" [nzMd]="8">
          <nz-form-item>
            <nz-form-label>Application Type</nz-form-label>
            <nz-form-control>
              <nz-select formControlName="applicationType" nzAllowClear nzPlaceHolder="All">
                <nz-option
                  *ngFor="let type of applicationTypes"
                  [nzValue]="type.value"
                  [nzLabel]="type.label"
                ></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col [nzXs]="24" [nzSm]="12" [nzMd]="8">
          <nz-form-item>
            <nz-form-label>Application ID / Registration No</nz-form-label>
            <nz-form-control>
              <input nz-input formControlName="searchText" placeholder="e.g. SRA-DHA-000050" />
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col [nzXs]="24" [nzMd]="8" class="d-flex align-items-end justify-content-end" style="padding-bottom: 24px">
          <button nz-button nzType="primary" type="submit">Search</button>
          <button nz-button nzType="default" type="button" style="margin-left: 12px" (click)="onRefresh()">
            Refresh
          </button>
        </div>
      </div>
    </form>
  </ng-container>

  <div class="ng-Header col-xs-12" [class.mt-4]="listType !== 'archive'">
    <i nz-icon nzType="unordered-list" nzTheme="outline"></i> {{ pageTitle }}
  </div>
  <div nz-col [nzSpan]="24">
    <nz-table
      #basicTable
      [nzData]="stpApplicationDto"
      nzTableLayout="fixed"
      nzShowSizeChanger
      nzBordered
      nzSize="middle"
      nzAlign="middle"
      [nzFrontPagination]="false"
      [nzTotal]="total"
      [(nzPageSize)]="size"
      [nzShowTotal]="totalRowRangeTemplate"
      [(nzPageIndex)]="page"
      (nzQueryParams)="onQueryParamsChange($event)"
      [nzScroll]="{ x: '1250px' }"
      [nzNoResult]="noApplicationTpl"
    >
      <!-- A new STP with no saved application yet has no row here, so offer the way into the registration form
           (the sidebar's Edit Application item was removed). -->
      <ng-template #noApplicationTpl>
        <nz-empty nzNotFoundContent="No application found"></nz-empty>
        <button
          *ngIf="listType === 'application' && isListLoaded && !hasActiveSearch"
          class="mt-2"
          nz-button
          nzType="primary"
          [routerLink]="['/home/stp-registration/dash-board']"
        >
          <i nz-icon nzType="form" nzTheme="outline"></i> Start Application
        </button>
      </ng-template>
      <ng-template
        #totalRowRangeTemplate
        let-range="range"
        let-total
        style="text-align: left"
      >
        <div style="text-align: left">
          Showing {{ range[0] }}-{{ range[1] }} of {{ total }} items
        </div>
      </ng-template>
      <thead>
        <tr>
          <th style="text-align: center; width: 70px">Sl.</th>
          <th>Name of STP</th>
          <th>Application ID</th>
          <th>Application Date</th>
          <th>Registration Number</th>
          <th>Approval Date</th>
          <th>Expire Date</th>
          <th>District</th>
          <th>Application Status</th>
          <th>Approval Status</th>
          <th nzRight>Action</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngIf="listType !== 'archive'">
        <tr *ngFor="let data of basicTable.data; let i = index">
          <td style="text-align: center">{{ (page - 1) * size + 1 + i }}</td>
          <td>{{ data.stpName }}</td>
          <td>
            <span *ngIf="data.applicationStatus == 'New Application'">
              <a
                [routerLink]="[
                  '/home/stp-registration/stp-application-view-renew-reapply',
                ]"
                [queryParams]="{
                  stpMainId: data.stpMainId,
                  stpMainDumpId: data.stpMainDumpId
                }"
                target="_blank"
                routerLinkActive="router-link-active"
                >{{ data.applicationId }}
              </a>
            </span>
            <span *ngIf="data.applicationStatus != 'New Application'">
              <a
                [routerLink]="[
                  '/home/stp-registration/stp-application-view/',
                  data.stpMainId,
                ]"
                target="_blank"
                routerLinkActive="router-link-active"
                >{{ data.applicationId }}
              </a>
            </span>
          </td>
          <td>{{ data.applicationDate | date: "dd-MM-yyyy" }}</td>
          <!-- Renewal/reapply rows ('New Application') show no registration number until approved -->
          <td>
            {{
              data.applicationStatus == 'New Application' && data.approval != true
                ? ''
                : data.registrationId
            }}
          </td>
          <td>{{ data.approvalDate | date: "dd-MM-yyyy" }}</td>
          <td>{{ data.expireDate | date: "dd-MM-yyyy" }}</td>
          <td>{{ data.districtName }}</td>
          <td style="text-align: center">
            <span
              *ngIf="
                data.isExpiringSoon &&
                !data.isRenewed &&
                data.applicationStatus != 'New Application'
              "
              class="badge"
              style="background-color: #e6de10; color: #000; font-size: 10px"
            >
              Expiring Soon
            </span>
            <!-- "New Application" is only the internal row type of the renewal / reapply copy: show which one it is -->
            <span
              *ngIf="data.applicationStatus == 'New Application' && listType == 'application'"
              class="badge badge-primary"
              style="font-size: 10px"
            >
              {{ data.isReapplied ? 'Reapply Application' : 'Renewal Application' }}
            </span>
            <span
              *ngIf="data.userStatus"
              class="badge {{
                data.userStatus.toLowerCase() == 'completed'
                  ? 'badge-success'
                  : 'badge-warning'
              }}"
              style="font-size: 10px"
            >
              {{ data.userStatus }}
            </span>
            <span
              *ngIf="!data.userStatus && data.applicationStatus == 'New Application'"
              class="badge badge-warning"
              style="font-size: 10px"
            >
              On Going
            </span>
            <span
              *ngIf="data.isTempRejected == false"
              class="badge badge-success"
              style="font-size: 10px"
            >
              Accepted
            </span>
            <span
              *ngIf="data.isTempRejected == true"
              class="badge badge-danger"
              style="font-size: 10px"
            >
              Correction Requested
            </span>
          </td>
          <td style="text-align: center">
            <span
              *ngIf="data.applicationStatus != 'New Application'"
              class="badge {{
                data.isExpired == false
                  ? data.approval == true
                    ? 'badge-success'
                    : 'badge-warning'
                  : 'badge-danger'
              }}"
              style="font-size: 10px"
            >
              {{
                data.isExpired == false
                  ? data.approval == true
                    ? "Approved"
                    : "Not Approved"
                  : "Expired"
              }} </span
            ><span
              *ngIf="data.applicationStatus == 'New Application'"
              class="badge"
              [ngClass]="(data.dumpApproval || data.approval) ? 'badge-success' : 'badge-warning'"
              style="font-size: 10px"
            >
              {{ (data.dumpApproval || data.approval) ? "Approved" : "Not Approved" }}
            </span>
            <!-- a closed renewal/reapply whose final decision was Not Approved -->
            <span *ngIf="data.decisionStatus == 'Not Approved'" class="badge badge-danger" style="font-size: 10px">
              {{ data.isReapplied ? "Reapply Not Approved" : "Renewal Not Approved" }}
            </span>
            <span
              *ngIf="
                data.stpInspectionDecisionFinalId === 6 &&
                (data.lastDecisionType === 'RENEWED' ||
                  data.lastDecisionType === 'REAPPLIED')
              "
              class="badge badge-warning"
              style="font-size: 10px"
            >
              {{
                data.lastDecisionType === "RENEWED"
                  ? "Renewal Not Approved"
                  : data.lastDecisionType === "REAPPLIED"
                    ? "Reapply Not Approved"
                    : ""
              }}
            </span>
          </td>
          <td align="center" nzRight>
            <button
              *ngIf="
                data.applicationStatus != 'New Application' &&
                data.userStatusId != 3
              "
              [appRequiredPermission]="
                applicationPermissions.stpRegistration.stpApplication
                  .editApplicationListButtonPermission
              "
              style="margin: 2px"
              nz-button
              nzType="primary"
              title="Edit"
              [routerLink]="['/home/stp-registration/dash-board']"
            >
              <i nz-icon nzType="edit" nzTheme="outline"></i>
            </button>

            <button
              *ngIf="
                data.applicationStatus == 'New Application' &&
                data.userStatusId != 3
              "
              [appRequiredPermission]="
                applicationPermissions.stpRegistration.stpApplication
                  .editApplicationListButtonPermission
              "
              style="margin: 2px"
              nz-button
              nzType="primary"
              title="Edit"
              [routerLink]="['/home/stp-registration/renew-reapply-dash-board']"
              [queryParams]="{
                  stpMainId: data.stpMainId,
                  stpMainDumpId: data.stpMainDumpId
                }"
            >
              <i nz-icon nzType="edit" nzTheme="outline"></i>
            </button>

            <!-- Re-Apply after Not Approved: on the STP's row and on the Not Approved renewal/reapply row; it stays
                 disabled for 90 days after the decision (the tooltip counts the days down). A disabled button gets
                 no hover, so the tooltip sits on the wrapper. -->
            <span
              *ngIf="(data.stpInspectionDecisionFinalId == 6 && !data.isRenewed) || data.decisionStatus == 'Not Approved'"
              nz-tooltip
              [nzTooltipTitle]="
                reApplyDaysLeft(data) > 0
                  ? 'You can re-apply after 90 days on ' + (data.reApplyAllowedFrom | date: 'dd-MM-yyyy') +
                    ' (' + reApplyDaysLeft(data) + (reApplyDaysLeft(data) == 1 ? ' day' : ' days') + ' left)'
                  : 'Re-apply Application'
              "
            >
              <button
                [appRequiredPermission]="
                  applicationPermissions.stpRegistration.stpApplication
                    .reApplyApplicationListButtonPermission
                "
                style="margin: 2px"
                nz-button
                nzType="primary"
                [disabled]="(!data.stpMainDumpId && data.isReapplied) || reApplyDaysLeft(data) > 0"
                [style.pointer-events]="(!data.stpMainDumpId && data.isReapplied) || reApplyDaysLeft(data) > 0 ? 'none' : null"
                nz-popconfirm
                nzPopconfirmTitle="Are you sure to re-apply this application? Once processed, it can not be changed!"
                (nzOnConfirm)="reApply(data.stpMainId)"
              >
                <i nz-icon nzType="swap" nzTheme="outline"></i>
              </button>
            </span>

            <button
              *ngIf="
                (data.isExpiringSoon || data.isExpired) &&
                !data.isReapplied &&
                data.userStatusId == 3 &&
                !data.stpMainDumpId &&
                data.stpInspectionDecisionFinalId != 6
              "
              [appRequiredPermission]="
                applicationPermissions.stpRegistration.stpApplication
                  .renewApplicationListButtonPermission
              "
              style="margin: 2px"
              nz-button
              nzType="primary"
              title="Renew Application"
              [disabled]="data.isRenewed"
              nz-popconfirm
              nzPopconfirmTitle="Are you sure to renew this application? Once processed, it can not be changed!"
              (nzOnConfirm)="renew(data.stpMainId)"
            >
              <i nz-icon nzType="retweet" nzTheme="outline"></i>
            </button>

            <button
              *ngIf="data.applicationStatus != 'New Application'"
              [appRequiredPermission]="
                applicationPermissions.stpRegistration.stpApplication
                  .downloadCertificateButtonPermission
              "
              style="margin: 2px"
              nz-button
              nzType="primary"
              title="Download Certificate"
              [disabled]="data.isExpired || !data.approval"
              (click)="downloadCertificate(data.stpMainId)"
            >
              <i nz-icon nzType="container" nzTheme="outline"></i>
            </button>

            <a
              *ngIf="data.applicationStatus != 'New Application'"
              [appRequiredPermission]="
                applicationPermissions.stpRegistration.stpApplicationView
                  .viewApplicationListButtonPermission
              "
              style="margin: 2px"
              nz-button
              nzType="primary"
              title="View Application"
              [routerLink]="[
                '/home/stp-registration/stp-application-view/' + data.stpMainId,
              ]"
              target="_blank"
              routerLinkActive="router-link-active"
              ><i
                nz-icon
                nzType="eye"
                style="color: white"
                nzTheme="outline"
              ></i>
            </a>

            <a
              *ngIf="data.applicationStatus == 'New Application'"
              [appRequiredPermission]="
                applicationPermissions.stpRegistration.stpApplicationView
                  .viewApplicationListButtonPermission
              "
              style="margin: 2px"
              nz-button
              nzType="primary"
              title="View Application"
              [routerLink]="[
                '/home/stp-registration/stp-application-view-renew-reapply',
              ]"
              [queryParams]="{
                stpMainId: data.stpMainId,
                stpMainDumpId: data.stpMainDumpId
              }"
              target="_blank"
              routerLinkActive="router-link-active"
              ><i
                nz-icon
                nzType="eye"
                style="color: white"
                nzTheme="outline"
              ></i>
            </a>

            <button
              *ngIf="
                !data.isExpired &&
                data.approval &&
                data.applicationStatus != 'New Application'
              "
              style="margin: 2px"
              nz-button
              nzType="primary"
              title="Correction Request"
              [routerLink]="[
                '/home/stp-registration/stp-correction-request/' +
                  data.stpMainId,
              ]"
              target="_blank"
              routerLinkActive="router-link-active"
            >
              <i nz-icon nzType="scissor" nzTheme="outline"></i>
            </button>
          </td>
        </tr>
        </ng-container>

        <!-- Archive List: previously approved versions, read-only -->
        <ng-container *ngIf="listType === 'archive'">
          <tr *ngFor="let data of basicTable.data; let i = index">
            <td style="text-align: center">{{ i + 1 }}</td>
            <td>{{ data.stpName }}</td>
            <td>
              <a
                [routerLink]="['/home/stp-registration/stp-application-view-renew-reapply']"
                [queryParams]="{ stpMainId: data.stpMainId, stpMainDumpId: data.stpMainDumpId, archived: true }"
                target="_blank"
                >{{ data.applicationId }}</a
              >
            </td>
            <td>{{ data.applicationDate | date: "dd-MM-yyyy" }}</td>
            <td>{{ data.registrationId }}</td>
            <td>{{ data.approvalDate | date: "dd-MM-yyyy" }}</td>
            <td>{{ data.expireDate | date: "dd-MM-yyyy" }}</td>
            <td>{{ data.districtName }}</td>
            <td style="text-align: center">
              <span class="badge badge-secondary" style="font-size: 10px">Archived</span>
              <span class="badge badge-info" style="font-size: 10px; margin-left: 2px">
                {{ data.isReapplied ? 'Before Reapply' : 'Before Renewal' }}
              </span>
            </td>
            <td style="text-align: center">
              <span class="badge badge-success" style="font-size: 10px">Previously Approved</span>
            </td>
            <td align="center" nzRight>
              <a
                [appRequiredPermission]="
                  applicationPermissions.stpRegistration.stpApplicationView
                    .viewApplicationListButtonPermission
                "
                style="margin: 2px"
                nz-button
                nzType="primary"
                title="View Archived Application"
                [routerLink]="['/home/stp-registration/stp-application-view-renew-reapply']"
                [queryParams]="{ stpMainId: data.stpMainId, stpMainDumpId: data.stpMainDumpId, archived: true }"
                target="_blank"
                ><i nz-icon nzType="eye" style="color: white" nzTheme="outline"></i>
              </a>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </nz-table>
  </div>
</div>
